import React from 'react';
import { Grid, Paper, Box, Typography } from '@mui/material';
import {
  TrendingUp as TrendingUpIcon,
  Schedule as ScheduleIcon,
  Timeline as TimelineIcon,
  AccountBalance as AccountBalanceIcon
} from '@mui/icons-material';
import { formatCurrency } from '../../utils/liquidacionHelpers';

const StatCard = ({ title, value, subtitle, icon, color }) => (
  <Paper sx={{
    p: 2, borderRadius: 3, border: `1px solid ${color}25`,
    background: `linear-gradient(135deg, ${color}08, ${color}04)`,
    transition: 'all 0.2s', '&:hover': { transform: 'translateY(-2px)', boxShadow: `0 6px 20px ${color}15` }
  }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box sx={{ width: 44, height: 44, borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: `linear-gradient(135deg, ${color}, ${color}CC)`, color: '#fff' }}>
        {React.cloneElement(icon, { sx: { fontSize: 22 } })}
      </Box>
      <Box>
        <Typography variant="h5" fontWeight={800} color={color} lineHeight={1.1}>{value}</Typography>
        <Typography variant="body2" fontWeight={600} color="#1A237E">{title}</Typography>
        {subtitle && <Typography variant="caption" color="text.secondary">{subtitle}</Typography>}
      </Box>
    </Box>
  </Paper>
);

const ResumenCards = ({ resumen = {} }) => {
  const { servicios_pendientes = {}, estadisticas_pagos = {} } = resumen;

  return (
    <Grid container spacing={1.5} sx={{ mb: 2.5 }}>
      <Grid item xs={6} sm={3}>
        <StatCard
          title="Serv. Pendientes"
          value={servicios_pendientes.servicios_sin_liquidar || 0}
          subtitle={formatCurrency(servicios_pendientes.comisiones_pendientes)}
          icon={<TrendingUpIcon />}
          color="#10B981"
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatCard
          title="Pagos Pendientes"
          value={estadisticas_pagos.pagos_pendientes || 0}
          subtitle={formatCurrency(estadisticas_pagos.monto_pendiente)}
          icon={<ScheduleIcon />}
          color="#F59E0B"
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatCard
          title="En Proceso"
          value={estadisticas_pagos.pagos_en_proceso || 0}
          subtitle={formatCurrency(estadisticas_pagos.monto_en_proceso)}
          icon={<TimelineIcon />}
          color="#3B82F6"
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatCard
          title="Pagado Este Mes"
          value={estadisticas_pagos.pagos_mes_actual || 0}
          subtitle={formatCurrency(estadisticas_pagos.monto_pagado_mes)}
          icon={<AccountBalanceIcon />}
          color="#8B5CF6"
        />
      </Grid>
    </Grid>
  );
};

export default ResumenCards;
